<template>
    <div class="vue-pop-up-modal">
        <perfect-scrollbar>
            <div class="modal-header d-flex justify-content-between align-items-start">
                <div class="information-button"></div>

                <button class="close-button mt-1" @click="handleClose">
                    {{ translations.closeText }}
                </button>
            </div>

            <div class="modal-body">
                <div class="modal-description" v-html="getPopUpSettings.text"></div>
            </div>

            <div class="modal-footer">
                <button @click="handleClose" class="btn-ghost btn-no-arrow">Geen interesse</button>
                <a v-if="hasButton" :href="getPopUpSettings.url" class="btn-primary btn-no-arrow">{{ getPopUpSettings.url_text }}</a>
            </div>
        </perfect-scrollbar>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import translations from "../../mixins/translations";

export default {
    name: "PopUpModal",

    mixins: [translations],

    computed: {
        ...mapGetters([
            'getPopUpSettings'
        ]),

        hasButton() {
            return !lodash.isNil(this.getPopUpSettings.url) && !lodash.isNil(this.getPopUpSettings.url_text)
        }
    },

    methods: {
        handleClose() {
            this.$modal.close()
        }
    }
}
</script>